import { phoneNumberFormatting, getName } from "js/formatting";
import { useTranslation } from "react-i18next";
import CardBase from "components/General/CardBase";
import Field from "components/General/Field";
import GridBase from "components/General/GridBase";
import React from "react";

export default function OwnerCard({
  owners,
  additionalContent,
  additionalChildComponent = null,
  badgeClass = null,
}) {
  const { t } = useTranslation();
  return (
    <CardBase
      additionalContent={additionalContent}
      ariaLabel={t("AgentOwnerCard-label")}
      cardTitle={t("AgentOwnerCard-ownercard-title")}
      badgeClass={badgeClass}
    >
      {additionalChildComponent}
      <GridBase>
        {owners.map((owner, id) => {
          const { addressLine1, addressLine2, city, postalCode, state } =
            owner.address;
          const { phoneNumber } = owner.phone;
          const { address: emailAddress } = owner.email;

          return (
            <React.Fragment key={id}>
              <Field
                title={t(
                  owner?.person?.partyTypeCode === "OW"
                    ? "AgentOwnerCard-owner"
                    : "AgentOwnerCard-Joint-owner"
                )}
                value={getName(owner.person)}
                hidden={false}
              />
              <Field
                title={t(
                  owner?.person?.partyTypeCode === "OW"
                    ? "AgentOwnerCard-owner-address"
                    : "AgentOwnerCard-Joint-owner-address"
                )}
                value={
                  <>
                    <p>{addressLine1}</p>
                    <p>{addressLine2}</p>
                    <p>{`${city}, ${state} ${postalCode?.substring(0, 5)}`}</p>
                  </>
                }
                hidden={false}
              />
              <Field
                title={t(
                  owner?.person?.partyTypeCode === "OW"
                    ? "AgentOwnerCard-owner-phone"
                    : "AgentOwnerCard-Joint-owner-phone"
                )}
                value={
                  <a href={`tel:+1${phoneNumber}`}>
                    {phoneNumberFormatting(phoneNumber)}
                  </a>
                }
                hidden={false}
              />
              <Field
                title={t(
                  owner?.person?.partyTypeCode === "OW"
                    ? "AgentOwnerCard-owner-email"
                    : "AgentOwnerCard-Joint-owner-email"
                )}
                value={
                  <a className="break-all" href={`mailto:${emailAddress}`}>
                    {emailAddress}
                  </a>
                }
                hidden={false}
              />
            </React.Fragment>
          );
        })}
      </GridBase>
    </CardBase>
  );
}
